import { render, staticRenderFns } from "./AppAnimation.vue?vue&type=template&id=0f5877f8&"
import script from "./AppAnimation.vue?vue&type=script&lang=js&"
export * from "./AppAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports